//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


    import { helper } from '~/mixins/helper'
    import { autocomplete } from '~/mixins/autocomplete'

    export default {

        name: 'Directory',

        //components: { LazyHydrate },

        mixins: [helper, autocomplete],

        data() {
            return {
                content: {},
                page: {},
                loadApi: false,
            }
        },

        /*watch: {
            '$fetchState.pending'(newState, oldState) {
                if(newState === true) {
                    this.$meta().pause()
                    this.$store.commit('tracking/status', 'waiting')
                } else {
                    this.$store.commit('tracking/status', 'ready')
                    this.$meta().resume()
                }
            }
        },*/

        head() {

            return this.$head()
                .setPage(this.page)
                .setBodyAttrs('directory-wrap')
                .get()

/*            let head = this.headerHead()
            head.bodyAttrs = {
                class: ['directory-wrap']
            }

            return head*/
        },

        async asyncData({ $xhrHelper, $logger }) {

            let content = {}, page = {}

            try {

                const resource = await $xhrHelper.getResourceById('directory')

                content = resource.content
                page = resource.page

            } catch (e) {
                $logger.captureException(e)
            }

            return { content: content, page: page }

        },


        /*async fetch() {

            try {
                //const response = await this.$axios.$get(this.route('api.content.directory.data'))
                const resource = await this.$xhrHelper.getResourceById('directory')
                this.content = resource.content
                this.page = resource.page
            } catch (e) {
                this.$logger.captureException(e)
            }

        },*/

        methods: {

        },

        computed: {

            isCrawler() {
                return this.$store.state.isCrawler
            },

        }

    }

